var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "wine_glass",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m70.093,38.776c0-4.497-1.435-12.821-3.731-20.666-.095-.383-.478-.67-.957-.67h-30.905c-.383,0-.766.286-.957.669-2.104,7.846-3.636,16.17-3.636,20.667,0,10.812,8.611,19.614,19.327,19.998v23.824l-16.935,4.018c-.766.191-1.148.861-1.052,1.531.095.766.67,1.244,1.435,1.244h35.114c.766,0,1.339-.574,1.435-1.244.095-.766-.383-1.435-1.052-1.531l-16.935-4.018v-23.825c10.429-.574,18.849-9.281,18.849-19.996h0Zm-6.41,48.796h-26.981l13.49-3.253,13.491,3.253Zm-13.682-30.617c-10.047,0-18.18-8.132-18.18-18.18,0-4.21,1.339-11.96,3.445-19.518h29.469c2.009,7.463,3.445,15.213,3.445,19.518,0,10.046-8.133,18.18-18.18,18.18h0Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }